module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Scale-31953dbcfd49b22d52d138acd83de61a.svg";